<template>
  <v-dialog v-model="dialog" max-width="420">
    <v-card>
      <v-card-title class="text-h6" style="background-color: #36304a; color: aliceblue;">
        <v-icon color="warning" size="x-small" style="padding-bottom: 5px;">mdi-delete</v-icon> {{ title }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        {{ message }}
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions style="background-color: #eedbf1">
        <v-spacer></v-spacer>
        <v-btn color="red darken-1"  variant="flat" @click="disagree">
          {{ options.btnDisagree }}
        </v-btn>
        <v-btn color="green darken-1"  variant="flat" @click="agree">
          {{ options.btnAgree }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmPopup",
  data() {
    return {
      dialog: false,
      title: "",
      message: "",
      options: {
        btnDisagree: "Disagree",
        btnAgree: "Agree",
      },
      agreeCallback: null,
      disagreeCallback: null,
    };
  },
  methods: {
    open({
      title,
      message,
      options = {
        btnDisagree: "Disagree",
        btnAgree: "Agree",
      },
      agree = () => {},
      disagree = () => {},
    }) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = options;
      this.agreeCallback = agree;
      this.disagreeCallback = disagree;
    },
    disagree() {
      this.dialog = false;
      this.disagreeCallback();
    },
    agree() {
      this.dialog = false;
      this.agreeCallback();
    },
  },
};
</script>
